import React, { useMemo, useState, type ChangeEvent } from "react";

import { validateOutputTemplate } from "@north-beam/nb-common";
import { TextInput } from "@shared/text-input";

import { getTemplateDetails } from "../utils";

import { OutputValueTemplates } from "./output-value-templates";

interface Props {
  output: string;
  matcher: any;
  error: string | null;
  onChange: (value: string) => void;
}

export const OutputValue = ({ output, matcher, error, onChange }: Props) => {
  const [templateError, setTemplateError] = useState("");

  const templateDetails = useMemo(() => getTemplateDetails(matcher), [matcher]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const errorMsg = validateOutputTemplate(
      value,
      templateDetails.flatMap((v) => v.templates),
    );

    setTemplateError(errorMsg);
    onChange(value);
  };

  return (
    <>
      <h4 className="m-0 text-xl font-bold mb-2">Output label value</h4>
      <div className="w-[260px] text-sm mt-3 mb-4">
        <TextInput
          label="OUTPUT LABEL"
          spellCheck={false}
          value={output}
          onChange={handleChange}
        />
        {(templateError || error) && (
          <div className="text-xxs text-mars mt-1">
            *{templateError || error}
          </div>
        )}
      </div>
      <OutputValueTemplates templateDetails={templateDetails} />
    </>
  );
};
